<template>
	<div id="app">
		<router-view />
		<Footer />
	</div>
</template>

<script>
import Footer from './components/Footer';
export default {
	name: 'MasterTemplate',

	components: {
		Footer,
	},
};
</script>

<style></style>
